import { useState } from 'react';
import Modal from 'react-modal';

export type AltTextModalProps = {
  isOpen: boolean;
  initialValue: string;
  onSave: (value: string) => void;
  onClose: () => void;
};

export function AltTextModal({
  isOpen,
  initialValue,
  onSave,
  onClose,
}: AltTextModalProps) {
  const [value, setValue] = useState(initialValue);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Edit alt text"
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      className="alt-text-modal"
      overlayClassName="alt-text-modal__overlay"
    >
      <h3>Edit alt text</h3>
      <p>
        Describe the image for users who can&apos;t see it. Leave blank if
        decorative.
      </p>
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        rows={3}
        autoFocus
      />
      <div className="alt-text-modal__actions">
        <button type="button" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          onClick={() => {
            onSave(value);
            onClose();
          }}
        >
          Save
        </button>
      </div>
    </Modal>
  );
}
